/* Ascendia product page, round 5 - 7 Oct 2026 (tools/pdp-round5-7oct2026/REPORT.md). Never throws, never edits the size engine.
   Config from snippets/asc-pdp-r5.liquid (window.ASC_R5). Six small parts, each in its own try:
   1 bar()      ADD TO CART bar on the FIRST screen of short phones, but only while it sits under the size buttons
   2 taps()     taps that did nothing: the "Size" label, the size box title, the two plain trust cells
   3 once()     one tap = one piece (second add within 3 s / while the first is on its way -> opens the bag) + "Added" state
   4 bnpl()     pay-later box: loading state, a clear next step + close over the Tabby / Tamara pop-ups
   5 soldOut()  sold-out size panel brought into view on a phone
   6 ceiling()  "XL+" for sizes we do not make: honest line + in-stock bigger pieces (live variants, from the liquid) */
(function () {
  'use strict';
  var C = window.ASC_R5;
  if (!C || window.__ascR5) return; window.__ascR5 = 1;
  var d = document, ar = !!C.ar;
  var mq = window.matchMedia('(max-width: 749px)');
  function q(s, r) { return (r || d).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function info() { return q('.product__info-container'); }
  function sizeFs() { var i = info(); return i && (q('fieldset.asc-size-fs', i) || qa('variant-radios fieldset, variant-selects fieldset', i).pop()); }
  function vis(e) { return !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)); }
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>';
  var T = ar ? {
    added: 'تمت الإضافة', bag: 'تمت الإضافة إلى حقيبتك.',
    loading: 'جارٍ التحميل…', opening: 'جارٍ الفتح…',
    slow: 'يستغرق وقتاً أطول من المعتاد. يمكنك اختيار تابي أو تمارا عند الدفع.',
    lead: 'اختر <b>تابي</b> أو <b>تمارا</b> في صفحة الدفع، بعد اختيار المقاس.',
    nextNo: 'اختر مقاسك، ثم اختر تابي أو تمارا عند الدفع.', nextYes: 'أضف القطعة إلى الحقيبة، ثم اختر تابي أو تمارا عند الدفع.',
    back: 'العودة إلى المنتج',
    upH: 'نصنع هذا الموديل حتى المقاس %M', upSub: 'متوفر الآن بمقاسات أكبر، بلمسة واحدة:', upNone: 'لا تتوفر حالياً قطع بمقاسات أكبر. فريقنا يساعدك على واتساب.',
    upWa: 'اسأل فريقنا على واتساب', sizes: 'متوفر: %S', chip: '%N وأكبر'
  } : {
    added: 'Added', bag: 'Added to your bag.',
    loading: 'Loading…', opening: 'Opening…',
    slow: 'This is taking longer than usual. You can also pick Tabby or Tamara at checkout.',
    lead: 'Pick <b>Tabby</b> or <b>Tamara</b> on the payment page, after you choose your size.',
    nextNo: 'Choose your size, then pick Tabby or Tamara at checkout.', nextYes: 'Add it to your bag, then pick Tabby or Tamara at checkout.',
    back: 'Back to the product',
    upH: 'We make this style up to %M', upSub: 'In bigger sizes, in stock now:', upNone: 'Nothing in bigger sizes is in stock right now. Our team can help on WhatsApp.',
    upWa: 'Ask our team on WhatsApp', sizes: 'In stock: %S', chip: '%N+'
  };
  function esc(s) { var x = d.createElement('div'); x.textContent = s == null ? '' : String(s); return x.innerHTML; }
  function sizePicked() { var fs = sizeFs(); return !!(fs && q('input[type="radio"]:checked', fs) && !d.querySelector('.asc-nosize')); }

  /* ---------------- 1. the ADD TO CART bar on the first screen ---------------- */
  function bar() {
    var b = q('.sticky-atc'), main = q('.product__info-container [id^="ProductSubmitButton-"]');
    if (!b || !main) return;
    var raf = 0;
    function guarded() {
      /* the colour + size buttons themselves (not their fieldset's empty margin), and any open panel under them */
      var gl = qa('.product__info-container variant-radios label, .product__info-container variant-selects label, .product__info-container variant-radios legend, .asc-r5-upchip, details.asc-sg-top .asc-sg__field, details.asc-sg-top input, .asc-so:not([hidden]), .asc-r5-up:not([hidden]), .asc-ns-msg:not([hidden])');
      /* 20 Oct 2026: on the very first screen (not scrolled yet) the size BUTTONS may sit under the bar - the height + weight box above them picks the size, and
         the bar must be there from the first screen. Once the shopper scrolls, the old rule is back: the bar never covers the size buttons while they are used. */
      var sf = sizeFs();
      if (sf && window.pageYOffset < 40) gl = gl.filter(function (el) { return !sf.contains(el); });
      return gl;
    }
    function sync() {
      raf = 0;
      if (!mq.matches) { b.classList.remove('always-visible'); return; }
      var vh = window.innerHeight, r = main.getBoundingClientRect();
      var on = r.height > 0;                                         /* 28 Oct (owner): the bar floats the whole time the shopper scrolls the product page */
      if (on && d.body.classList.contains('asc-so-on')) on = false;    /* sold-out panel: the bar is hidden by its own rule */
      var a = d.activeElement;
      if (on && a && a.matches && a.matches('input, select, textarea') && a.closest('.product__info-container')) on = false;  /* typing */
      var bh = b.offsetHeight || 72, band = vh - bh;
      if (on) {
        var f = q('.footer__content-bottom'), fr = f && f.getBoundingClientRect();
        if (fr && fr.top < vh && fr.bottom > 0) on = false;
      }
      /* also wait for the page to have been seen for a moment: no bar flashing in during the first paint */
      b.classList.toggle('always-visible', on);
    }
    function soon() { if (!raf) raf = requestAnimationFrame(sync); }
    window.addEventListener('scroll', soon, { passive: true });
    window.addEventListener('resize', soon);
    d.addEventListener('focusin', soon); d.addEventListener('focusout', function () { setTimeout(soon, 50); });
    d.addEventListener('change', function () { setTimeout(soon, 60); setTimeout(soon, 1000); });
    d.addEventListener('click', function () { setTimeout(soon, 120); });
    if ('ResizeObserver' in window) { var i0 = info(); if (i0) new ResizeObserver(soon).observe(i0); }
    [0, 400, 1200, 2500].forEach(function (ms) { setTimeout(soon, ms); });
  }

  /* ---------------- 2. taps that did nothing ---------------- */
  function taps() {
    var fs = sizeFs();
    if (fs) {
      var leg = q('legend', fs) || q('.form__label', fs);
      var head = leg && leg.parentNode !== fs ? leg.parentNode : leg;
      if (head) head.addEventListener('click', function (e) {
        if (e.target.closest('a, button, modal-opener')) return;           /* "Size guide" keeps its own job */
        var first = qa('input[type="radio"]', fs).filter(function (x) { return !x.disabled && !x.classList.contains('disabled'); })[0] || q('input[type="radio"]', fs);
        fs.classList.remove('asc-ns-nudge'); void fs.offsetWidth; fs.classList.add('asc-ns-nudge');
        setTimeout(function () { fs.classList.remove('asc-ns-nudge'); }, 1600);
        if (first) try { first.focus({ preventScroll: true }); } catch (x) { /* old browser */ }
      });
    }
    /* the size box title (summary has pointer-events:none in round 3, so the tap lands on the box itself): go to the first empty box */
    var box = q('details[data-asc-sg-quickwrap].asc-r3');
    if (box) box.addEventListener('click', function (e) {
      if (e.target.closest('input, select, button, a, label, textarea')) return;
      var inp = qa('input', box).filter(function (x) { return vis(x) && !x.value; })[0];
      if (inp) { e.preventDefault(); try { inp.focus(); } catch (x) { /* ignore */ } }
    });
    /* trust cells: the two that had no action open the delivery details, like "1-2 working days" (round 2 handler) */
    function trust() {
      qa('.product__info-container .asc-trust > .asc-trust__item').forEach(function (it) {
        if (it.tagName === 'A' || it.hasAttribute('data-asc-open')) return;
        it.setAttribute('data-asc-open', 'ship'); it.setAttribute('role', 'button'); it.tabIndex = 0;
      });
    }
    trust(); setTimeout(trust, 1500);
  }

  /* ---------------- 3. one tap = one piece, and an obvious "Added" ---------------- */
  function once() {
    var busy = {}, last = { id: null, t: 0 };
    function idOf(form) { var i = form && form.querySelector('[name="id"]'); return i ? String(i.value) : null; }
    function openBag() { var cd = q('cart-drawer'); if (cd && typeof cd.open === 'function') { try { cd.open(); } catch (e) { /* ignore */ } } }
    window.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[action*="/cart/add"]') || f.classList.contains('installment')) return;
      var id = idOf(f); if (!id) return;
      var now = Date.now();
      if (busy[id] && now - busy[id] < 8000 || (last.id === id && now - last.t < 3000)) {
        e.preventDefault(); e.stopImmediatePropagation();
        if (!busy[id]) openBag();
        return;
      }
      /* the size gate (round 2) may still stop this submit: only count it once it really goes */
      setTimeout(function () {
        var pf = f.closest('product-form'), sb = pf && pf.querySelector('[type="submit"]');
        if (sb && (sb.classList.contains('loading') || sb.getAttribute('aria-disabled') === 'true')) busy[id] = Date.now();
      }, 0);
    }, true);
    function done(ok, id) {
      Object.keys(busy).forEach(function (k) { delete busy[k]; });
      if (!ok) return;
      last = { id: id, t: Date.now() };
      qa('.product__info-container [id^="ProductSubmitButton-"], .sticky-atc .sticky-atc-button').forEach(function (btn) {
        if (btn.classList.contains('asc-r5-added')) return;
        var s = d.createElement('span'); s.className = 'asc-r5-ok'; s.setAttribute('aria-hidden', 'true'); s.innerHTML = CHECK + '<span>' + esc(ar ? T.added : T.added.toUpperCase()) + '</span>';
        btn.appendChild(s); btn.classList.add('asc-r5-added');
        setTimeout(function () { btn.classList.remove('asc-r5-added'); if (s.parentNode) s.parentNode.removeChild(s); }, 2200);
      });
      /* the bag: one calm line on top, so the shopper knows it worked and sees CHECK OUT */
      setTimeout(function () {
        var cd = q('cart-drawer'); if (!cd) return;
        var hd = q('.drawer__header', cd); if (!hd) return;
        var n = q('.asc-r5-drawer-ok', cd);
        if (!n) { n = d.createElement('p'); n.className = 'asc-r5-drawer-ok'; n.setAttribute('role', 'status'); hd.parentNode.insertBefore(n, hd.nextSibling); }
        n.innerHTML = CHECK + '<span>' + esc(T.bag) + '</span>'; n.hidden = false;
        clearTimeout(n.__t); n.__t = setTimeout(function () { n.hidden = true; }, 6000);
      }, 350);
    }
    /* PUB_SUB_EVENTS is a top-level const in the theme's pubsub.js: visible by name, not as window.PUB_SUB_EVENTS */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) { if (ev && ev.source === 'product-form') done(true, String(ev.productVariantId || '')); });
      subscribe(PUB_SUB_EVENTS.cartError, function () { done(false); });
    }
  }

  /* ---------------- 4. pay-later box ---------------- */
  function bnpl() {
    var det = q('.product__info-container details.asc-bnpl');
    if (!det) return;
    var body = q('.asc-bnpl__body', det); if (!body) return;
    /* our own line first: what to do next, no waiting for anybody's script */
    if (!q('.asc-r5-bnpl-lead', body)) {
      var lead = d.createElement('p'); lead.className = 'asc-r5-bnpl-lead'; lead.innerHTML = T.lead;
      body.insertBefore(lead, body.firstChild);
    }
    /* a calm "Loading..." for each partner block until it has drawn itself */
    function blocks() { return qa('[data-tabby-promo], tamara-widget, .asc-tamara-promo', body).filter(function (x) { return !x.closest('.asc-tamara-promo') || x.classList.contains('asc-tamara-promo'); }); }
    var skel = d.createElement('div'); skel.className = 'asc-r5-skel'; skel.hidden = true; skel.innerHTML = '<i class="asc-r5-spin" aria-hidden="true"></i><span>' + T.loading + '</span>';
    var lead0 = q('.asc-r5-bnpl-lead', body); body.insertBefore(skel, lead0 ? lead0.nextSibling : body.firstChild);
    function wait(on) { skel.hidden = !on; body.classList.toggle('asc-r5-wait', on); }
    function drawn() {
      var t = q('[data-tabby-promo]', body), m = q('tamara-widget', body);
      var tOk = !t || t.offsetHeight > 20 || t.childElementCount > 0;
      var mOk = !m || (m.shadowRoot && m.shadowRoot.childElementCount > 0 && m.offsetHeight > 20);
      return tOk && mOk;
    }
    var poll = 0;
    det.addEventListener('toggle', function () {
      if (!det.open) { wait(false); return; }
      if (drawn()) return;
      wait(true);
      var n = 0; clearInterval(poll);
      poll = setInterval(function () { n++; if (drawn() || n > 40) { wait(false); clearInterval(poll); } }, 200);
    });

    /* a tap on a partner block: show "Opening..." until its pop-up is up; then a clear next step + way back */
    var pill = d.createElement('div'); pill.className = 'asc-r5-pill'; pill.hidden = true; pill.setAttribute('role', 'status');
    var next = d.createElement('div'); next.className = 'asc-r5-next'; next.hidden = true; next.setAttribute('role', 'region');
    next.innerHTML = '<p></p><button type="button">' + esc(T.back) + '</button>';
    d.body.appendChild(pill); d.body.appendChild(next);
    function popup() {
      /* something full-screen sits over the page centre and is not part of our page = the partner pop-up */
      var e = d.elementFromPoint(window.innerWidth / 2, window.innerHeight / 3), hops = 0;
      while (e && e.shadowRoot && e.shadowRoot.elementFromPoint && hops++ < 4) { var inner = e.shadowRoot.elementFromPoint(window.innerWidth / 2, window.innerHeight / 3); if (!inner || inner === e) break; e = inner; }
      if (!e || e === next || next.contains(e) || e === pill) return null;
      var host = e.getRootNode && e.getRootNode().host;
      var el = host || e;
      if (el.closest('.product__info-container, .product__media-wrapper, header, .section-header, .announcement-bar, cart-drawer, .footer, main')) {
        /* a shadow-DOM pop-up inside tamara-widget is inside main: accept it only when it covers the screen */
        if (!host) return null;
        var hr = e.getBoundingClientRect();
        if (hr.width < window.innerWidth * 0.85) return null;
      }
      var w = e, guard = 0;
      while (w && guard++ < 30) { var cs = getComputedStyle(w); if (cs.position === 'fixed') return w; w = w.parentElement || (w.getRootNode && w.getRootNode().host) || null; }
      return null;
    }
    var watch = 0, t0 = 0, seen = null;
    function stop() { clearInterval(watch); watch = 0; pill.hidden = true; }
    function tick() {
      var p = popup();
      if (p) {
        seen = p; pill.hidden = true;
        next.querySelector('p').textContent = sizePicked() ? T.nextYes : T.nextNo;
        if (next.hidden || next !== d.body.lastElementChild) d.body.appendChild(next);   /* stay above a pop-up added after us */
        next.hidden = false;
        return;
      }
      if (seen) { seen = null; next.hidden = true; stop(); return; }        /* the pop-up was closed with its own X */
      var el = Date.now() - t0;
      if (el > 350 && el < 7000) { pill.hidden = false; pill.innerHTML = '<i class="asc-r5-spin" aria-hidden="true"></i><span>' + T.opening + '</span>'; }
      if (el >= 7000) { pill.innerHTML = '<span>' + esc(T.slow) + '</span>'; }
      if (el > 11000) stop();
    }
    body.addEventListener('click', function (e) {
      if (!e.target.closest('[data-tabby-promo], tamara-widget, .asc-tamara-promo')) return;
      t0 = Date.now(); seen = null; clearInterval(watch); watch = setInterval(tick, 150);
    }, true);
    next.querySelector('button').addEventListener('click', function () {
      var p = seen || popup();
      next.hidden = true; stop();
      if (p) {
        /* close it the way its own X does; if that is not reachable, take it off the screen */
        var x = null;
        try {
          var root = p.getRootNode ? p.getRootNode() : d;
          var cands = qa('button, [role="button"]', p).concat(root !== d && root.querySelectorAll ? qa('button, [role="button"]', root) : []);
          x = cands.filter(function (b) { var l = (b.getAttribute('aria-label') || '') + ' ' + (b.className && b.className.baseVal === undefined ? b.className : '') + ' ' + (b.textContent || ''); return /close|إغلاق|dismiss|×|✕/i.test(l); })[0] || null;
          if (!x) { var r = p.getBoundingClientRect(); var tr = (root.elementFromPoint ? root : d).elementFromPoint(r.right - 30, r.top + 36); x = tr && tr.closest && tr.closest('button, [role="button"]'); }
        } catch (err) { x = null; }
        if (x) x.click(); else if (p.parentNode) p.style.display = 'none';
        try { d.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true })); } catch (err) { /* ignore */ }
      }
      setTimeout(function () {
        var tgt = sizePicked() ? q('.product__info-container [id^="ProductSubmitButton-"]') : sizeFs();
        if (tgt) { var r = tgt.getBoundingClientRect(); if (r.top < 80 || r.bottom > window.innerHeight - 90) window.scrollTo({ top: window.pageYOffset + r.top - 140, behavior: 'smooth' }); }
      }, 250);
    });
  }

  /* ---------------- 5. sold-out panel: bring it into view ---------------- */
  function soldOut() {
    var lastTap = 0;
    d.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('variant-radios, variant-selects')) lastTap = Date.now(); }, true);
    function look() {
      if (!mq.matches || Date.now() - lastTap > 2500) return;
      var p = q('.asc-so:not([hidden])'); if (!p || !d.body.classList.contains('asc-so-on')) return;
      /* the panel AND the "Notify me" button (STOQ) under it, when both fit; the panel's top never goes under the header */
      var st = q('.product__info-container .restock-rocket-button');
      var r = p.getBoundingClientRect(), vh = window.innerHeight, bottom = r.bottom;
      if (st && vis(st)) { var sr = st.getBoundingClientRect(); if (sr.bottom - r.top < vh - 90) bottom = Math.max(bottom, sr.bottom); }
      if (bottom > vh - 8) window.scrollTo({ top: window.pageYOffset + Math.min(bottom - vh + 20, r.top - 80), behavior: 'smooth' });
    }
    d.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-radios, variant-selects')) { setTimeout(look, 450); setTimeout(look, 1200); } });
  }

  /* ---------------- 6. sizes we do not make ---------------- */
  function ceiling() {
    var fs = sizeFs();
    if (!fs || !C.max || !C.next) return;
    var alts = (C.alts || []).slice();
    if (!alts.length) return;                 /* nothing bigger to offer: no chip (the box's own words stay) */
    /* her own department first (a women's piece -> women's pieces before unisex), then the same kind of piece or a set,
       then the widest size run */
    var rank = function (a) { return (a.a && a.a === C.aud ? 0 : 10) + (a.ty && a.ty === C.ty ? 0 : (/set/i.test(a.ty || '') ? 1 : 2)); };
    alts.sort(function (a, b) { return rank(a) - rank(b) || (b.s.length - a.s.length); });
    alts = alts.slice(0, 3);
    var panel = d.createElement('div'); panel.className = 'asc-r5-up'; panel.hidden = true; panel.id = 'AscR5Up'; panel.setAttribute('role', 'region'); panel.setAttribute('aria-live', 'polite');
    var range = function (s) { return s.length > 1 ? s[0] + '–' + s[s.length - 1] : s[0]; };
    panel.innerHTML = '<p class="asc-r5-up__h">' + esc(T.upH.replace('%M', C.max)) + '</p><p class="asc-r5-up__sub">' + T.upSub + '</p><ul class="asc-r5-up__list">' +
      alts.map(function (a) {
        return '<li><a href="' + esc(a.u) + '">' + (a.i ? '<img src="' + esc(a.i) + '" alt="" width="44" height="44" loading="lazy">' : '') +
          '<span>' + esc(a.t) + '<small>' + esc(T.sizes.replace('%S', '')) + '<bdi dir="ltr">' + esc(range(a.s)) + '</bdi></small></span>' + ARROW + '</a></li>';
      }).join('') + '</ul>';
    var chip = d.createElement('button'); chip.type = 'button'; chip.className = 'asc-r5-upchip';
    chip.textContent = T.chip.replace('%N', C.next); chip.setAttribute('aria-expanded', 'false'); chip.setAttribute('aria-controls', 'AscR5Up');
    var labels = qa('label', fs).filter(function (l) { return !l.classList.contains('color-swatch'); });
    var lastL = labels[labels.length - 1];
    if (!lastL) return;
    lastL.parentNode.insertBefore(chip, lastL.nextSibling);
    var under = fs.nextElementSibling && fs.nextElementSibling.classList.contains('asc-sg-under') ? fs.nextElementSibling : fs;
    under.parentNode.insertBefore(panel, under.nextSibling);
    function show(on) {
      panel.hidden = !on; chip.setAttribute('aria-expanded', String(on));
      if (on && mq.matches) { var r = panel.getBoundingClientRect(); if (r.bottom > window.innerHeight - 80) window.scrollTo({ top: window.pageYOffset + r.bottom - window.innerHeight + 96, behavior: 'smooth' }); }
    }
    chip.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(panel.hidden); });
    /* a real size tap closes it */
    fs.addEventListener('change', function () { show(false); });

    /* the usual-size row (round 4, Active Fit): one more answer, "XL+" */
    function usualRow() {
      var o = q('.asc-r4-usual__o'); if (!o) return false;
      if (q('[data-r5-up]')) return true;
      /* its own little group right after round 4's buttons (round 4 repaints every button inside its group) */
      var wrap = d.createElement('span'); wrap.className = 'asc-r5-uo';
      var b = d.createElement('button'); b.type = 'button'; b.setAttribute('data-r5-up', ''); b.setAttribute('aria-expanded', 'false'); b.textContent = T.chip.replace('%N', C.next);
      wrap.appendChild(b); o.parentNode.insertBefore(wrap, o.nextSibling);
      var p2 = panel.cloneNode(true); p2.id = 'AscR5UpBox'; p2.classList.add('asc-r5-up--box'); p2.hidden = true;
      b.setAttribute('aria-controls', 'AscR5UpBox');
      var host = q('.asc-r4-only') || o.parentNode;
      host.parentNode.insertBefore(p2, host.nextSibling);
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var on = b.getAttribute('aria-expanded') !== 'true';
        /* her usual size can't be both: clear a usual size picked before (round 4 clears on a second tap of the same button) */
        var pr = q('button[data-u][aria-pressed="true"]', o); if (on && pr) pr.click();
        b.setAttribute('aria-expanded', String(on));
        p2.hidden = !on;
      });
      o.addEventListener('click', function (e) { if (e.target.closest('button[data-u]')) { b.setAttribute('aria-expanded', 'false'); p2.hidden = true; } });
      return true;
    }
    if (!usualRow()) { setTimeout(usualRow, 800); setTimeout(usualRow, 2500); }

    /* the height + weight answer says "L, our biggest size, may be too small" and the box has no route of its own: add ours */
    var res = q('details[data-asc-sg-quickwrap] [data-asc-sg-result]');
    if (res && 'MutationObserver' in window) {
      var mine = null;
      var check = function () {
        var tight = !res.hidden && res.classList.contains('is-tight');
        var w = res.querySelector('[data-asc-sg-wider-list]');
        var routed = w && w.children.length > 0;
        if (tight && !routed) {
          if (!mine) { mine = panel.cloneNode(true); mine.id = ''; mine.classList.add('asc-r5-up--ans'); mine.querySelector('.asc-r5-up__h').hidden = true; }
          if (!mine.parentNode || mine.parentNode !== res) res.appendChild(mine);
          mine.hidden = false;
        } else if (mine) mine.hidden = true;
      };
      new MutationObserver(function () { setTimeout(check, 0); }).observe(res, { attributes: true, attributeFilter: ['class', 'hidden'] });
      check();
    }
  }

  /* 14 Oct 2026: photo as big as the first screen allows. After load, measure where the Height/Weight box ends and grow or shrink the
     photo box so the box ends just above the browser's bottom toolbar (svh = Safari's small viewport, toolbars shown). Phones only. */
  function fit() {
    var mq = window.matchMedia && window.matchMedia('(max-width: 749px)');
    var conts = qa('.product .product-media-container');
    var cont = conts.filter(function (c) { return c.getClientRects().length; })[0];
    var box = q('.asc-sg-quickwrap .asc-sg-quick') || q('.asc-sg-quickwrap');
    if (!cont || !box || !box.getClientRects().length || box.getBoundingClientRect().height < 40) return;
    var probe = d.createElement('div');
    probe.style.cssText = 'position:fixed;left:0;top:0;width:0;height:100vh;height:100svh;visibility:hidden;pointer-events:none';
    d.body.appendChild(probe);
    var svh = probe.getBoundingClientRect().height;
    d.body.removeChild(probe);
    if (!(svh > 300)) svh = window.innerHeight; // old browsers and some emulators report 0 for svh
    var lastW = -1, tries = 0;
    function run() {
      if (!mq || !mq.matches) { conts.forEach(function (c) { c.style.removeProperty('--asc-cap'); }); return; }
      if (window.pageYOffset > 40) return; // never move the page under a shopper who already scrolled
      var cs = getComputedStyle(cont);
      var cur = cont.getBoundingClientRect().height;
      var bottom = box.getBoundingClientRect().bottom + window.pageYOffset;
      /* 20 Oct 2026: leave room for the sticky ADD TO CART bar, so the bar can show on the first screen. If that would make the photo
         smaller than 300 px (a short screen), fall back to the old rule: the bar then waits (bar() above keeps it off the size box). */
      var stk = q('.sticky-atc'), barH = (stk && stk.offsetHeight) || 70;
      var next = cur + (svh - 4 - barH - 20 - bottom);   /* the bar sits about 8 px above the screen edge, so allow 20 px beyond its height */
      if (next < 300) next = cur + (svh - 4 - bottom);
      var max = Math.min(window.innerWidth * 1.05, 520), min = svh < 640 ? 140 : 180;
      next = Math.max(min, Math.min(max, next));
      if (Math.abs(next - cur) < 3) return;
      conts.forEach(function (c) { c.style.setProperty('--asc-cap', Math.round(next) + 'px'); });
    }
    [200, 700, 1600, 3200].forEach(function (ms) { setTimeout(run, ms); }); // photos, fonts and the size box settle at different times; each pass measures again
    var t; window.addEventListener('resize', function () { if (window.innerWidth === lastW) return; lastW = window.innerWidth; tries = 0; clearTimeout(t); t = setTimeout(function () { conts.forEach(function (c) { c.style.removeProperty('--asc-cap'); }); setTimeout(run, 80); setTimeout(run, 700); }, 250); }, { passive: true });
  }

  function boot() {
    [bar, taps, once, bnpl, soldOut, ceiling].forEach(function (f) { try { f(); } catch (e) { /* never break the page */ } });
    try { if (d.readyState === 'complete') fit(); else window.addEventListener('load', fit); } catch (e) { /* the CSS cap is the fallback */ }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
